"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorrelationSortableColumns = void 0;
var CorrelationSortableColumns;
(function (CorrelationSortableColumns) {
    CorrelationSortableColumns["correlationId"] = "correlationId";
    CorrelationSortableColumns["createdAt"] = "createdAt";
})(CorrelationSortableColumns = exports.CorrelationSortableColumns || (exports.CorrelationSortableColumns = {}));
//# sourceMappingURL=Correlation.js.map